import { create } from 'zustand';

export interface PlayerActionTarget {
  uid: string;
  name: string;
  klass: 'warrior' | 'wizard' | 'archer';
  screenX: number;
  screenY: number;
}

interface PlayerActionState {
  target: PlayerActionTarget | null;
  open: (t: PlayerActionTarget) => void;
  close: () => void;
}

export const usePlayerActionStore = create<PlayerActionState>((set) => ({
  target: null,
  open: (t) => set({ target: t }),
  close: () => set({ target: null }),
}));
